module.exports = __webpack_public_path__ + "img/WF_21_sm.921e3c68.jpg";